module.exports = __webpack_public_path__ + "static/media/marron.cf9e1326.png";